import { useState } from "react";
import { Twitter, Link2, Check } from "lucide-react";

const quotes = [
  {
    text: "Success is a myth. Chaos is a guarantee. Have a cupcake.",
    ep: "The TCC Tagline",
  },
  {
    text: "You don't need to have it figured out. You need people who'll sit with you while you don't.",
    ep: "Ep.05 — Is This a Cult?",
  },
  {
    text: "Community isn't a product. It's the thing that happens when you stop performing.",
    ep: "Ep.03 — Sober Coliving",
  },
];

export const QuoteCards = () => {
  const [copiedIdx, setCopiedIdx] = useState(null);

  const shareTwitter = (text, ep) => {
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
      `"${text}" — ${ep}, Truths Chaos & Cupcakes 🧁\n\nhttps://tccpodcast.com`
    )}`;
    window.open(url, "_blank");
  };

  const copyQuote = (text, ep, idx) => {
    const fullText = `"${text}" — ${ep}, Truths Chaos & Cupcakes`;
    try {
      navigator.clipboard.writeText(fullText);
    } catch {
      const textarea = document.createElement("textarea");
      textarea.value = fullText;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    }
    setCopiedIdx(idx);
    setTimeout(() => setCopiedIdx(null), 2000);
  };

  return (
    <section className="px-5 sm:px-8 lg:px-12 py-14 sm:py-20 md:py-32 bg-[#0C0C14] border-y border-[#232332]" data-testid="quote-cards-section">
      <div className="mb-12 min-w-0">
        <p className="overline-tcc mb-4">Steal these. Share these.</p>
        <h2 className="font-display text-4xl sm:text-6xl md:text-7xl leading-[0.9] text-[#F4F2EE] break-words">
          Quotable <span className="text-[#FF3E8A]">chaos</span>
        </h2>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#232332] border border-[#232332]">
        {quotes.map((q, i) => (
          <div
            key={i}
            className="relative bg-[#0C0C14] hover:bg-[#10101A] p-6 md:p-10 flex flex-col justify-between min-h-0 md:min-h-[220px] group transition-colors duration-200"
            data-testid={`quote-card-${i}`}
          >
            <p className="font-serif-tcc italic text-xl md:text-2xl text-[#F4F2EE] leading-snug">
              &ldquo;{q.text}&rdquo;
            </p>

            <div className="flex items-center justify-between gap-3 mt-6 md:mt-8">
              <span className="font-mono-tcc text-[10px] uppercase tracking-[0.2em] text-[#5E5E72] min-w-0 truncate">{q.ep}</span>
              <div className="flex gap-2 shrink-0">
                <button
                  onClick={() => shareTwitter(q.text, q.ep)}
                  className="w-9 h-9 border border-[#323248] hover:border-[#FF3E8A] hover:bg-[#FF3E8A] hover:text-[#08080D] text-[#F4F2EE] flex items-center justify-center transition-colors duration-150"
                  aria-label="Share on Twitter"
                  data-testid={`quote-share-twitter-${i}`}
                >
                  <Twitter size={13} />
                </button>
                <button
                  onClick={() => copyQuote(q.text, q.ep, i)}
                  className="w-9 h-9 border border-[#323248] hover:border-[#C8FF3E] hover:bg-[#C8FF3E] hover:text-[#08080D] text-[#F4F2EE] flex items-center justify-center transition-colors duration-150"
                  aria-label="Copy quote"
                  data-testid={`quote-copy-${i}`}
                >
                  {copiedIdx === i ? <Check size={13} /> : <Link2 size={13} />}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
